import View from './view/CanViewMarketplaceInitialState'

const { Record } = require('immutable');

export default Record({
    view: View()
});